import React, { useState } from "react";
import { Link } from "react-router-dom";
import IconPlususer from "../SvgIcons/IconPlususer";
import IconDots from "../SvgIcons/IconDots";
import "./style.scss";

export default function CardContainer() {
  // Manage the active tabs and show/hide lists using a single state object
  const [state, setState] = useState({
    activeTab1: 0,
    activeTab2: 0,
    showList1: false,
    showList2: false,
  });

  const cardContents1 = [
    {
      picture: "../images/admin-pictures/picture.png",
      name: "Ryan Septimus",
      date: "Wed May 15, 2024",
      title: "Great Two Day Trip",
      description:
        "During your visit to California, you experienced the diverse beauty and vibrant culture of the Golden...",
    },
    {
      picture:
        "https://fastly.picsum.photos/id/1/300/400.jpg?hmac=awzPRCuK7uysi8_WJRKklwR47Xq8C6sDtUFwcWGLDB4",
      name: "Sophia Turner",
      date: "Fri July 10, 2024",
      title: "Amazing Adventure",
      description:
        "Explore the wonders of the Grand Canyon and enjoy breathtaking views that you'll never forget...",
    },
    {
      picture:
        "https://d3k81ch9hvuctc.cloudfront.net/company/W2tUD9/images/1ca1cde2-0c03-4e9f-a9c2-d3d641cc8bd3.png",
      name: "John Doe",
      date: "Mon August 20, 2024",
      title: "Weekend Getaway",
      description:
        "Relax and unwind during your weekend trip to the serene beaches of the Pacific Northwest...",
    },
  ];

  const cardContents2 = [
    {
      picture: "../images/admin-pictures/picture1.png",
      name: "Alice Johnson",
      date: "Tue June 15, 2024",
      title: "City Lights Adventure",
      description:
        "Discover the urban charm and vibrant nightlife in the heart of the city that never sleeps...",
    },
    {
      picture:
        "https://fotykgy.stripocdn.email/content/guids/CABINET_af1ea23f103f40fcdacc1928c631e097/images/7511583308739728.png",
      name: "Mark Spencer",
      date: "Sat July 17, 2024",
      title: "Mountain Escape",
      description:
        "Enjoy a peaceful retreat to the mountains where you can hike, relax, and breathe in the fresh air...",
    },
    {
      picture:
        "https://fotykgy.stripocdn.email/content/guids/CABINET_af1ea23f103f40fcdacc1928c631e097/images/87581578489757145.png",
      name: "Lucy Green",
      date: "Sun September 12, 2024",
      title: "Beach Paradise",
      description:
        "Soak up the sun and enjoy the pristine beaches with crystal-clear waters and white sand...",
    },
  ];

  const handleTabClick = (box, index) => {
    setState((prevState) => ({
      ...prevState,
      [box]: index,
    }));
  };

  const toggleList = (list) => {
    setState((prevState) => ({
      ...prevState,
      [list]: !prevState[list],
    }));
  };

  const renderCardBox = (cardContents, activeTabKey, showListKey) => (
    <div className="card-septimus">
      <div className="tabtop">
        <ul className="pictabs">
          {cardContents.map((content, index) => (
            <li key={index}>
              <Link
                to="#"
                className={state[activeTabKey] === index ? "active" : ""}
                onClick={(e) => {
                  e.preventDefault(); // Prevent default link behavior
                  handleTabClick(activeTabKey, index); // Update the active tab
                }}
              >
                <img
                  src={`../images/admin-pictures/ellipse${index + 1}.png`}
                  alt={`ellipse ${index + 1}`}
                />
              </Link>
            </li>
          ))}
        </ul>

        <div className="addbutton">
          <Link to="#" className="adduser">
            <IconPlususer />
          </Link>
          <Link
            to="#"
            className="LineUser"
            onClick={(e) => {
              e.preventDefault();
              toggleList(showListKey);
            }}
          >
            <IconDots />
          </Link>
        </div>
      </div>
      {state[showListKey] && (
        <ul className="dropdown-list">
          <li>
            <Link to="#">Option 1</Link>
          </li>
          <li>
            <Link to="#">Option 2</Link>
          </li>
          <li>
            <Link to="#">Option 3</Link>
          </li>
        </ul>
      )}
      <div className="card-content">
        <div className="card-picture">
          <img
            src={cardContents[state[activeTabKey]].picture}
            alt="bg picture"
          />
        </div>
        <div className="card-text">
          <h5>{cardContents[state[activeTabKey]].name}</h5>
          <span>{cardContents[state[activeTabKey]].date}</span>
        </div>
        <div className="during">
          <strong>{cardContents[state[activeTabKey]].title}</strong>
          <p>{cardContents[state[activeTabKey]].description}</p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="card-septimus-main">
      {renderCardBox(cardContents1, "activeTab1", "showList1")}
      {renderCardBox(cardContents2, "activeTab2", "showList2")}
    </div>
  );
}
